import { HttpContext, HttpContextToken } from '@angular/common/http';

export const IS_PUBLIC_ROUTE = new HttpContextToken<boolean>(() => false);

export function withPublicRoute(): (ctx: HttpContext) => HttpContext {
  return (ctx: HttpContext) => ctx.set(IS_PUBLIC_ROUTE, true);
}
